//Console.log Fallback for Internet Explorer
if ( !window.console ) {
    window.console = new function() {
        this.log = function(str) {};
        this.dir = function(str) {};
    };
};

(function( larderbox, $, undefined ) {

    // DO NOT EDIT THIS FILE IN Shopify or it may get overridden!

    // 0 = sun, 6 = sat
    // monday delivery cutoff = sat 12pm
    // friday delivery = thu 12pm

    var validDeliveryDates = {};

    //  {'cutoff_day': 6, 'cutoff_hour': 12, 'delivery_day': 8}
    //  {'cutoff_day': 1, 'cutoff_hour': 13, 'delivery_day': 2}

  // maybe out by 1 hour? timestamp said the right time?
  
    var deliveryDateRules = [
        {'cutoff_day': -2, 'cutoff_hour': 0, 'delivery_day': 1},
        {'cutoff_day': 4, 'cutoff_hour': 0, 'delivery_day': 5}
    ];

    var deliveryPostcodes = {
        '1': [1,2,3],
        '2': [1,2,3],
        '3': [5,6,7,8,9],
        '4': [1,2,3,4,5,6,7,8],
        '5': [1,2,3],
        '6': [4,5,6,7,8],
        '7': [4,5,6,9],
        '8': [7,8,9],
        '9': [1,2,3],
        '10': [4,5,6],
        '11': [1,2,3],
        '12': [5,6,7],
        '13': [0,9],
        '14': [1,2,3,4,5,6,7],
        '15': [1,2,3],
        '16': [4,5,6],
        '17': [7,8],
        '22': [1]
    }

    // difference in milliseconds from clients computer and the Shopify server
    var serverOffset;

    larderbox.init = function() {

        // use in page template to get server time, and use offset to get up to date time when requested
        var serverDate = moment.unix(now_ts);
        serverOffset = moment(serverDate).diff(new Date());

        initValidDeliveryDates(5); // allow 2 weeks in future

    }

    larderbox.getCurrentServerTime = function() {
        return moment().add(serverOffset, 'milliseconds');
    }

    function initValidDeliveryDates(weeks) {

        validDeliveryDates = {};
      
        var now = larderbox.getCurrentServerTime();
        
        //var min = moment('2017-01-08');
      
        for(week = 0; week < weeks; week++) {

            // fixed issue where we jumped 2 weeks as were modifying startOfWeek each loop
            var startOfWeek = moment(now).startOf('week');   
          
            startOfWeek.add(week * 7, 'days');
          

            $.each(deliveryDateRules, function(index, rule) {
                // make a moment object from the rules (adding 1 hour, still to debug whats happening)
                var ruleCutoffDate = moment(startOfWeek).add(rule.cutoff_day, 'days').hour(rule.cutoff_hour);
              
                if (now.isBefore(ruleCutoffDate)) {
                    // add to valid delivery dates (calculate the actual delivery date)
                    var ruleDeliveryDate = moment(startOfWeek).add(rule.delivery_day, 'days');
                  
                  // temp min date
                  //if (ruleDeliveryDate.isAfter(min)) {
                    
                  
                  // only allow a friday if no subscription item in basket
                  var ruleDeliveryDayOfWeek = ruleDeliveryDate.format('E');
                  
                  
                  if (!(ruleDeliveryDayOfWeek == 5 && subscription_in_basket)) {
                  
                    var formattedDate = ruleDeliveryDate.format('DD/MM/YYYY');
                    
                  console.log("day of week " + ruleDeliveryDayOfWeek);
                    
                    
                    validDeliveryDates[formattedDate] = {'cutoff_date': ruleCutoffDate, 'delivery_date': ruleDeliveryDate};
                  
                  }
                  
                  //}
                  
                }
            });
        }
    }
  
  
      function initCountdown() {

        // take off an hour (2 now, as we add an hour to the cutoff - see above)
        var nextCutoff = validDeliveryDates[Object.keys(validDeliveryDates)[0]].cutoff_date.clone();
        
        //nextCutoff.subtract(2, 'h');

      
        $('.clock').countdown(nextCutoff.format('YYYY/MM/DD HH:mm:ss'), function(event) {
            $(this).html(event.strftime('<div><span class="num">%-D</span><span>Day%!D</span></div> <div><span class="num">%-H</span><span>Hour%!H</span></div><div><span class="num">%-M</span><span>Min%!M</span></div>'));
        }).on('finish.countdown', function(event) {
            $(this).parent().find('.info').html('<p>Refresh page for next delivery</p>');
        })
        ;

    }
  

    // public method
    larderbox.isValidDeliveryDate = function(value) {

        var now = larderbox.getCurrentServerTime();

      //console.log(now);    
      //console.log(validDeliveryDates[value].cutoff_date);
      
        return (!validDeliveryDates.hasOwnProperty(value) ? false : now.isBefore(validDeliveryDates[value].cutoff_date));
    };

    larderbox.isValidDeliveryPostcode = function(value) {

        var regexp = /^\s*([a-z]{2})(\d{1,2})\s*(\d)[a-z]{2}\s*$/i;

        var matches = regexp.exec(value);

        if (!matches) {
            return false;
        }

        var d = matches[2];
        var s = matches[3];

        return (!deliveryPostcodes.hasOwnProperty(d) ? false : $.inArray(parseInt(s), deliveryPostcodes[d]) > -1);

    };

    function addCustomDeliveryDateValidator() {



        $.validator.addMethod("delivery_date", function(value, element) {
            return this.optional(element) || larderbox.isValidDeliveryDate(value);
        }, "Please choose a valid delivery date");

    }

    function addCustomDeliveryPostcodeValidator() {

        $.validator.addMethod("delivery_postcode", function(value, element) {
            return this.optional(element) || larderbox.isValidDeliveryPostcode(value);
        }, "This is not a valid delivery postcode.");

    }

    function initDeliveryDatePicker() {

      
        console.log(validDeliveryDates);
    
      
        var validDatesArray = [true];
        $.each(validDeliveryDates, function(index, value) { validDatesArray.push(value.delivery_date.toArray().slice(0,3)); });

      
        $('#delivery_date').pickadate({
            disable: validDatesArray,          
            format: 'dd/mm/yyyy',
            firstDay: 1,
            onOpen: function() {
                larderbox.scrollIntoView( this.$node, 120)
            }
        });

    }

    larderbox.scrollIntoView = function ( $node, offset) {
        $('html,body').animate({
            scrollTop: ~~$node.offset().top - offset
        })
    }

    larderbox.initBasketPage = function() {


        addCustomDeliveryDateValidator();
        addCustomDeliveryPostcodeValidator();
        initDeliveryDatePicker();

        // the date input won't get validated when made readonly by date picker
        // so we toggle the readonly on exit focus
        $("#cart_form").submit(function() {
            $('input#delivery_date').prop('readonly', false);
        });

        $(document).on("focusin", "input#delivery_date", function(event) {
            $(this).prop('readonly', true);
        });

        $("#cart_form").validate(
            {
                debug: false,
                focusInvalid: false,
                rules: {
                    'attributes[delivery_date]': {
                        required: true,
                        delivery_date: true
                    },
                    'attributes[delivery_postcode_edin]': {
                        required: true,
                        delivery_postcode: true
                    },
                    'attributes[delivery_postcode]': {
                        required: true,
                        remote: "http://tools.abbey.local/validate/postcode/lon",
                      
                    }
                },
                messages: {
                    'attributes[delivery_date]':     { required: 'Please choose a delivery date'},
                    'attributes[delivery_postcode]': { required: 'Please enter your delivery address postcode', remote: 'Sorry, but we currently don\'t deliver to your location. UK delivery is coming soon though!'}
                },
                invalidHandler: function(event, validator) {
                    var errors = validator.numberOfInvalids();
                    if (errors) {
                        larderbox.scrollIntoView($('input#delivery_date'), 120);
                    }
                },
                errorPlacement: function(error, element) {
                    error.insertBefore(element);
                }
            }
        );

    }

    // stop people getting to checkout without valid delivery date or postcode
    function initCheckoutValidator() {
        $('a[href$=checkout]').click(function() { return checkoutLinkAllowed() });

    }

    // links with a class of scrollToView will behave differently
    function initScrollToView() {

        $('a.scrollToView').click(
            function(e) {
                e.preventDefault();
                var scrollTarget = $($(this).attr('href'));
                larderbox.scrollIntoView(scrollTarget, 96);
            }

        );

    }


    function checkoutLinkAllowed() {

        var valid = false;
        var msg;

        if (!cart_delivery_date) {
            msg = "You must specify a delivery date for your order. \n\nPress OK to be taken the basket page where you can enter your required delivery date.";
        } else if (!larderbox.isValidDeliveryDate(cart_delivery_date)) {
            msg = "The delivery date you entered is no longer valid.\nPerhaps the cut-off time has passed?. \n\nPress OK to be taken the basket page where you can change your delivery date.";
        } else if (!cart_delivery_postcode) {
            msg = "You must specify a delivery postcode for your order. \n\nPress OK to be taken the basket page where you can enter your delivery postcode.";
        } else if (!larderbox.isValidDeliveryPostcode(cart_delivery_postcode)) {
            msg = "The delivery postcode you entered is not a valid LarderBox delivery postcode. \n\nPress OK to be taken the basket page where you can change your delivery postcode.";
        } else {
            valid = true;
        }

        if (!valid) {
            // redirect them to cart (do we show the message? eg via url param) unless they have a chechout submit button

            if ($('form#cart_form input[type=submit]').length > 0) {

                // first close side menu if it is open
                $('div#cart.mm-menu').trigger('close.mm');

                $('form#cart_form input[type=submit]').trigger('click');

            } else {
                window.location = "/cart";
            }

            return false;
        }

        return true;

    }

    larderbox.initReferAFriend = function() {
        
        $("form#recommend-a-friend").validate(
            {
                debug: false,
                focusInvalid: true,
                rules: {
                    'n':    { required: true },
                    'r':    { required: true, email: true },
                    'f[1]': { email: true, required: true },
                    'f[2]': { email: true },
                    'f[3]': { email: true },
                    'f[4]': { email: true },
                    'f[5]': { email: true }
                },
                messages: {
                    'n': { required: 'Please enter your name'},
                    'r': { required: 'Please enter your email address'},
                    'f[1]': { required: 'Please enter at least one friends email address'}
                },
                invalidHandler: function(event, validator) {
                    var errors = validator.numberOfInvalids();
                    if (errors) {
                        //
                    }
                },
                errorPlacement: function(error, element) {
                    error.insertBefore(element);
                },
                submitHandler: function(form) {


                    var $btn = $('.btn.action_button');
                    var $form = $(form);
                    $btn.data('old-label', $btn.val());
                    $btn.val("Please wait...");
                    $btn.attr('disabled', 'disabled');

                    $('form').parent().find('.alert-box').remove();

                    $.ajax({
                        type: 'post',
                        url: refer_a_friend_url,
                        data: $(form).serialize()
                    }).done(function(r) {
                        if (r.success) {
                            // clear email addresses...
                            $('#ref_1, #ref_2, #ref_3, #ref_4, #ref_5').val('');
                            // create a success box
                           if ($('form').parent().find('.alert-box').length == 0) {
                               $form.prepend('<div class="alert-box success">' + r.message + '</div>');
                               larderbox.scrollIntoView($form, 100);
                           }
                        } else {
                        	
                        }
                    }).fail(function() {
                        // Optionally alert the user of an error here...
                        alert("There was a problem submitting the form. Please try again.");
                    }).always(function() {
                        $btn.val($btn.data('old-label'));
                        $btn.removeAttr('disabled');
                    });


                }
            }
        );

    }
    
    larderbox.recalculateDeliveryDates = function() {
    
        
        initValidDeliveryDates(5); // this will recalculate to remove Fridays if necessary
        initDeliveryDatePicker();
      
    
    }
    

    larderbox.init();

    $(function(){
        // if on the basket page, initialise it...
        if ($('form#cart_form').length) {
            larderbox.initBasketPage();
        }
        // if on the basket page, initialise it...
        if ($('form#recommend-a-friend').length) {
            larderbox.initReferAFriend();
        }

        // todo - change behaviour on cart page
        initCheckoutValidator();

        initScrollToView();
      
        initCountdown();
      
    });

}( window.larderbox = window.larderbox || {}, jQuery ));